import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import {
  genericHeliosRequest,
  HeliosServerSideRequest,
} from '@helios/server-side-util'
import { Observable } from 'rxjs'
import { map, take } from 'rxjs/operators'

export const TRANSACTIONS_URL = `helios-ext-transactions`

export interface ExternalTransaction {
  extTranId: number
  secIdentifier?: string
  tranTypeCode?: string
  units?: number
  amount?: number
  price?: number
  tradeDate?: string
  settleDate?: string
  postDate?: string
  currencyCode?: string
  accrued?: number
  commission?: number
  dataSourceType?: string
  accountId: number
}
export const ExternalTransactionKeys: (keyof ExternalTransaction)[] = [
  'extTranId',
  'secIdentifier',
  'tranTypeCode',
  'units',
  'amount',
  'price',
  'tradeDate',
  'settleDate',
  'postDate',
  'currencyCode',
  'accrued',
  'commission',
  'dataSourceType',
  'accountId',
]

@Injectable()
export class ExternalTransactionsService {
  constructor(private readonly http: HttpClient) {}

  private getTransactions(
    request: HeliosServerSideRequest<ExternalTransaction>,
  ): Observable<ExternalTransaction[]> {
    return this.http
      .post<{
        data: ExternalTransaction[]
      }>(TRANSACTIONS_URL, request)
      .pipe(map(response => response.data))
  }

  getTransactionsByIds(extTxIds: number[]): Observable<ExternalTransaction[]> {
    return this.getTransactions(
      this.getHeliosRequestFromExternalIds(extTxIds),
    ).pipe(take(1))
  }

  private getHeliosRequestFromExternalIds(extTxIds: number[]) {
    return {
      ...genericHeliosRequest,
      endRow: extTxIds.length,
      fields: ExternalTransactionKeys,
      filter: {
        extTranId: {
          filterType: 'number',
          operator: 'AND',
          filters: [
            {
              operator: 'in',
              values: extTxIds,
            },
          ],
        },
      },
    } as HeliosServerSideRequest<ExternalTransaction>
  }
}
